export const ACTION = 'action';
export const SUBMITTER_ID = 'submitterId';
export const IS_REVIEWER = 'isReviewer';
export const IS_HIDDEN = 'isHidden';
export const EMPTY = '';
export const INDEX = 'index';
export const DATA_PREFIX = 'data.';
